import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import AuthCallback from './AuthCallback';
import CreateDeliveryDetailedPage from './screens/deliveries/CreateDeliveryDetailedPage.jsx';
import { CPAY_CALLBACK_PATH, INVOICES_PAGE_PATH, TOKEN_CALLBACK_PATH } from './utils/constants';
import { routes } from './utils/routerHelper';
import FAQPage from './screens/faq/FAQPage';
import SearchPage from './screens/search/SearchPage';
import DashboardPage from './screens/deliveries/DashboardPage';
import CheckoutRedirect from './components/CheckoutRedirect/CheckoutRedirect';
import CheckoutBackRedirect from './components/CheckoutBackRedirect/CheckoutBackRedirect';
import EmptyPage, { EMPTY_PAGE_USECASE } from './screens/pageNotFound/EmptyPage';
import CompletedDeliveriesPageV2 from './screens/deliveries/CompletedDeliveriesPageV2';
import AddressesV2 from './screens/profile/AddressesV2';
import PaymentsV2 from './screens/profile/PaymentsV2';
import ProfileV2 from './screens/profile/ProfileV2';
import ActiveDeliveryPageV2 from './screens/deliveries/ActiveDeliveryPageV2';

const AppRouter = (props: any) => (
  <Switch>
    <Route exact path="/">
      <Redirect to={routes.deliveriesDetailed} />
    </Route>
    <Route exact path={routes.deliveriesLean}>
      <Redirect to={routes.deliveriesDetailed} />
    </Route>
    <ProtectedRoute
      exact
      path={routes.deliveriesDetailed}
      component={CreateDeliveryDetailedPage}
      componentProps={props}
    />
    <ProtectedRoute
      exact
      path={[routes.activeDeliveries, routes.activeDeliveriesWithParam]}
      component={ActiveDeliveryPageV2}
      componentProps={props}
    />
    <ProtectedRoute
      exact
      path={[routes.pastDeliveries, routes.pastDeliveriesWithParam]}
      component={CompletedDeliveriesPageV2}
      componentProps={props}
    />
    <ProtectedRoute exact path={routes.deliveriesDashboard} component={DashboardPage} componentProps={props} />
    <ProtectedRoute exact path={routes.profile} component={ProfileV2} componentProps={props} />
    <ProtectedRoute exact path={routes.addresses} component={AddressesV2} componentProps={props} />
    <ProtectedRoute exact path={routes.payments} component={PaymentsV2} componentProps={props} />
    <ProtectedRoute exact path={routes.faq} component={FAQPage} componentProps={props} />
    <ProtectedRoute exact path={routes.search} component={SearchPage} componentProps={props} />
    <Route path={TOKEN_CALLBACK_PATH} component={AuthCallback} />
    <ProtectedRoute exact path={INVOICES_PAGE_PATH} component={CheckoutRedirect} componentProps={props} />
    <ProtectedRoute exact strict path={CPAY_CALLBACK_PATH} component={CheckoutBackRedirect} componentProps={props} />
    <ProtectedRoute
      component={() => <EmptyPage useCase={EMPTY_PAGE_USECASE.PAGE_NOT_FOUND} />}
      componentProps={props}
    />
  </Switch>
);

export default AppRouter;
